export enum PageTab {
  Templates = 'templates',
  Mine = 'mine',
  Archived = 'archived'
}
